
 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();

export const getAttendees = async (openTimeID) => {
    const response = await authenticatedFetch(`${config.API_BASE_URL}/attendeesOpenHome/${openTimeID}`, {
        method: 'GET',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        }
      });
      if (response.ok) {
        const responseData = await response.json();
        return responseData; 
      } else {
        throw new Error(`Error getting attendees`);
       }
     
};